module.exports = __webpack_public_path__ + "img/footer-payments.07dc3d2b.png";